<div>
  <div class="quick-actions">
    <div class="select-all-buttons">
      <mat-checkbox [checked]="canViewAll" (change)="toggleAllViews($event)"
        >{{ 'incidentManagement.share.allCanView' | t }}</mat-checkbox
      >
      <mat-checkbox [checked]="canEditAll" (change)="toggleAllEdits($event)"
        >{{ 'incidentManagement.share.allCanEdit' | t }}</mat-checkbox
      >
    </div>
  </div>
</div>
<mat-dialog-content>
  <mat-table [dataSource]="items" style="max-height: 525px">
    <ng-container matColumnDef="groupName">
      <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let group">
        {{ group.name }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="canView">
      <mat-header-cell *matHeaderCellDef>{{ 'common.canView' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let group">
        <mat-checkbox
          [checked]="group.canView"
          (change)="controlActions($event, group.id, 'view')"
        ></mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="canEdit">
      <mat-header-cell *matHeaderCellDef>{{ 'common.canEdit' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let group">
        <mat-checkbox
          [checked]="group.canEdit"
          (change)="controlActions($event, group.id, 'edit')"
        ></mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="isAdmin">
      <mat-header-cell *matHeaderCellDef>{{ 'common.admin' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let group">
        <mat-checkbox
          [checked]="group.isAdmin"
          (change)="controlActions($event, group.id, 'admin')"
        ></mat-checkbox>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
    <mat-row matRipple *matRowDef="let user; columns: columns"> </mat-row>
  </mat-table>
</mat-dialog-content>
<mat-dialog-actions>
  <sn-flat-button color="danger" mat-dialog-close class="cancelButton">{{ 'common.cancel' | t }}</sn-flat-button>
  <sn-flat-button color="success" (click)="save()" class="saveButton">{{ 'common.save' | t }}</sn-flat-button>
</mat-dialog-actions>
